module.exports = "<div class=\"row\">\n  <div class=\"card col-12 col-sm-4\" *ngFor=\"let shoppingItem of shoppingItems | async\" (click)=\"itemForSale(shoppingItem)\">\n    <img src='{{shoppingItem.image}}' class=\"image\" alt=\"image of kinfolk item for sale\">\n    <p class=\"tag\">{{shoppingItem.tag}}</p>\n    <p class=\"title\">{{shoppingItem.title}}</p>\n    <p class=\"price\">{{shoppingItem.price}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/julia/Desktop/kinfolk/src/app/shop/shop.component.html
// module id = ../../../../../src/app/shop/shop.component.html
// module chunks = main